module.exports = __webpack_public_path__ + "img/p1.2f38e3bd.jpeg";